import React, { Component } from 'react';
import $ from 'jquery';

export class DropdownMultipleFieldView extends Component {

  refresh() {
    $(`.ui.dropdown.renderDropDownMultiple`).dropdown({
      forceSelection: false
    });
  }

  render() {

    let {
      intl,
      translation,
      input,
      required,
      idField = 'id',
      displayField = 'name',
      activeOnly = true,
      label,
      list = []
    } = this.props;
    
    if (intl && translation) {
      const labelObj = translation.label;
      if(labelObj && labelObj.message) {
        label = intl.formatMessage(labelObj.message, labelObj.params);
      }
    }

    const requiredClass = required ? 'required' : '';

    let content = [];

    if (!Array.isArray(input.value)) {
      input.value = [input.value];
    }


    const optionList = list.reduce((accumulator = [], item) => {
      if (item) {
        const idVal = item[idField];
        if (idVal != null) {
          const optionId = idVal;
          const optionValue = idVal;
          const optionLabel = item[displayField];

          const inputValues = input && input.value;
          inputValues.forEach((input) => {
            if(input === optionValue){
              content.push(optionLabel);
            }
          });

          if (activeOnly) {
            if (!item.hasOwnProperty('active') || item.active) {
              accumulator.push((
                <option key={optionId} value={optionValue}>{optionLabel}</option>
              ));
            }
          }
          else {
            accumulator.push((
              <option key={optionId} value={optionValue}>{optionLabel}</option>
            ));
          }
        }
      }
      return accumulator;
    }, []);

    console.log("optionList", optionList);


      return (
        <div className={`${requiredClass} field`}>
          <label>{label}</label>
          <span>{content.join(', ')}</span>
          <div>
            <input type="hidden" name={input.name} value={input.value}/>
          </div>
        </div>
      );



  }
}
